(() => {
  const hosts = new Set(['lovesquishy.com', 'lovesquishy.pl', 'lovesquishy.es']);
  if (!hosts.has(window.location.hostname)) return;

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action, window.location.origin);
    if (action.origin !== window.location.origin || action.pathname !== '/localization') return;

    const country = form.querySelector('[name="country_code"]')?.value;
    const returnField = form.querySelector('[name="return_to"]');
    if (!country || !returnField) return;

    const destination = country === 'PL' ? 'lovesquishy.pl' : country === 'ES' ? 'lovesquishy.es' : 'lovesquishy.com';
    if (destination === window.location.hostname) return;

    const returnUrl = new URL(returnField.value || window.location.pathname, window.location.origin);
    if (!hosts.has(returnUrl.hostname) || returnUrl.protocol !== 'https:') return;
    returnUrl.searchParams.delete('_gl');

    const link = document.createElement('a');
    link.href = `https://${destination}${returnUrl.pathname}${returnUrl.search}${returnUrl.hash}`;
    link.hidden = true;
    link.addEventListener('click', (clickEvent) => clickEvent.preventDefault());
    document.body.append(link);

    try {
      link.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true, button: 0 }));
      link.click();
      const linker = new URL(link.href).searchParams.get('_gl');
      if (!linker) return;
      returnUrl.searchParams.set('_gl', linker);
      returnField.value = `${returnUrl.pathname}${returnUrl.search}${returnUrl.hash}`;
    } finally {
      link.remove();
    }
  }, true);
})();
